var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64.00 64.00",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 4.16,
    stroke: "#1C274C",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5,31a23.93,23.93,0,0,1-.41,5.44,23.51,23.51,0,0,1-42.37,9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49,32.6a23.26,23.26,0,0,1,.42-5A23.51,23.51,0,0,1,51.2,18.43",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40.63 17.46 51.48 18.73 52.56 8.55",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.08 46.19 12.24 44.92 11.15 55.1",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.79,22.57h2.92c2.85,0,6,.94,6,5.27,0,4.71-4,6.51-8.22,6a.25.25,0,0,0-.2.42l9,9.67",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.14,
    y1: 22.57,
    x2: 28.07,
    y2: 22.57,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.94,
    y1: 28,
    x2: 38.21,
    y2: 28,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.e209f80b4aee0e3cc5512eadf4de053b.svg";
export { ForwardRef as ReactComponent };